import React from 'react';

const Auth0Context = React.createContext();

const Auth0Provider = Auth0Context.Provider;

const Auth0Consumer = Auth0Context.Consumer;

export { Auth0Provider, Auth0Consumer };

export default Auth0Context;